(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
function secasaMoveCategories() {
  if (!document.querySelector('[data-section-type="collection"]')) return;
  Array.from(document.querySelectorAll('[data-section-type="collection-grid"]')).sort(function(a,b) {
    var order = ['Shop by room', 'Shop by category', 'Shop by brands'];
    return order.indexOf((a.querySelector('.section__title') || {}).textContent?.trim()) - order.indexOf((b.querySelector('.section__title') || {}).textContent?.trim());
  }).forEach(function(grid) {
    var heading = grid.querySelector('.section__title');
    var target = document.querySelector('.collection__dynamic-part');
    if (heading && ['Shop by category', 'Shop by room', 'Shop by brands'].includes(heading.textContent.trim()) && target) {
      target.parentNode.insertBefore(grid.closest('.shopify-section'), target);
      var row = grid.querySelector('.collection-grid');
      if (!row || row.parentElement.classList.contains('secasa-category-carousel')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'secasa-category-carousel';
      row.parentNode.insertBefore(wrapper, row);
      wrapper.appendChild(row);
      var previous = document.createElement('button');
      var next = document.createElement('button');
      previous.type = next.type = 'button';
      previous.className = 'secasa-category-arrow secasa-category-arrow--prev';
      next.className = 'secasa-category-arrow secasa-category-arrow--next';
      previous.setAttribute('aria-label', 'Previous categories');
      next.setAttribute('aria-label', 'Next categories');
      previous.textContent = '‹';
      next.textContent = '›';
      wrapper.appendChild(previous);
      wrapper.appendChild(next);
      function update() {
        previous.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      }
      previous.addEventListener('click', function() { row.scrollBy({left:-row.clientWidth, behavior:'smooth'}); });
      next.addEventListener('click', function() { row.scrollBy({left:row.clientWidth, behavior:'smooth'}); });
      row.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(row);
      update();
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', secasaMoveCategories);
else secasaMoveCategories();
document.addEventListener('shopify:section:load', secasaMoveCategories);

  } catch(e) { console.error(e); }
})();
})();
